import {
    FormControl,
    InputLabel,
    Select,
    SelectProps
  } from '@mui/material';
  import { FC } from 'react';
  import './AppSelect.css'; 
  
  export const AppSelect: FC<{
    label?: string;
    required?: boolean;
  } & Omit<SelectProps, 'variant'>> = ({ required, label, children, ...props }) => (
    <div className="app-text-field">
      <FormControl fullWidth>
        {label && <InputLabel>{label}</InputLabel>}
        <Select label={label} {...props}>{children}</Select>
      </FormControl>
      {required && (
        <div className="app-text-field-required">
          <div className="app-text-field-required-content">*</div>
        </div>
      )}
    </div>
  );
  